// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyBfrzsAwDCif5uhk3D17nGsomX0Wy5Xr3g',
  authDomain: 'whatsapp-clone-8d286.firebaseapp.com',
  projectId: 'whatsapp-clone-8d286',
  storageBucket: 'whatsapp-clone-8d286.appspot.com',
  messagingSenderId: '270744655500',
  appId: '1:270744655500:web:39717f039e63e9f0e98da9',
  measurementId: 'G-19H2R8C68G',
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

const db = firebaseApp.firestore()

const auth = firebase.auth()

const provider = new firebase.auth.GoogleAuthProvider()

export { auth, provider }

export default db
